import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";

function plClass(value) {
    const n = Number(value);
    if (Number.isNaN(n) || n === 0) return '';
    return n > 0 ? 'positive' : 'negative';
}

function formatPl(value) {
    const n = Number(value);
    if (Number.isNaN(n)) return '—';
    const prefix = n > 0 ? '+' : '';
    return `${prefix}${n.toFixed(2)}`;
}

const Indicator = (props) => {
    const data = props.item || {};

    return (
        <section className="stock-card">
            <div className="stock-card-body">
                <h2 className="stock-section-title">
                    <Translate value="stock_my_stats" />
                </h2>
                <div className="stock-stats-grid">
                    <div className="stock-stat">
                        <span className="stock-stat-label">P/L</span>
                        <span className={`stock-stat-value ${plClass(data.pl)}`}>
                            {formatPl(data.pl)}
                            <small style={{ fontSize: '0.75rem', color: '#64748b' }}> USD</small>
                        </span>
                    </div>
                    <div className="stock-stat">
                        <span className="stock-stat-label">
                            <Translate value="stock_trades_stock" />
                        </span>
                        <span className="stock-stat-value">{data.countSt ?? '—'}</span>
                    </div>
                    <div className="stock-stat">
                        <span className="stock-stat-label">
                            <Translate value="stock_trades_option" />
                        </span>
                        <span className="stock-stat-value">{data.countOp ?? '—'}</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

Indicator.propTypes = {
    className: PropTypes.string,
};

function mapStateToProps(reducer) {
    return {
        item: reducer.stockNews.data,
    };
}

export default connect(mapStateToProps)(Indicator);
